'use client';

import { useMemo } from 'react';

import { useAppSelector } from '@/redux-store/hooks';
import { getRoleType } from '@/utils/role';

function useUserRole() {
    const userInformation = useAppSelector(state => state.auth.userInformation);

    const roleType = useMemo(
        () => getRoleType(),
        [userInformation?.clientRole]
    );

    return { userInformation, roleType };
}

export default useUserRole;
